import { ConfirmModal } from "./ConfirmModal";
import { translateWithFallback as t } from "./translateWithFallback";

type CancelRunModalProps = {
    isOpen: boolean;
    onStay: () => void;
    onCancelRun: () => void;
};

export const CancelRunModal = ({ isOpen, onStay, onCancelRun }: CancelRunModalProps) => (
    <ConfirmModal
        isOpen={isOpen}
        dataAutomationPrefix="market-builder-v2-cancel-run"
        title={t("market.builder.v2.cancelRun.title", "Cancel finding domains?")}
        body={t(
            "market.builder.v2.cancelRun.body",
            "The agent will stop looking for websites and everything found so far will be lost. You cannot undo this action.",
        )}
        dismissLabel={t("market.builder.v2.cancelRun.stay", "Keep going")}
        confirmLabel={t("market.builder.v2.cancelRun.confirm", "Yes, cancel")}
        dismissButtonType="flatDark"
        onDismiss={onStay}
        onConfirm={onCancelRun}
    />
);
